// extracted by mini-css-extract-plugin
export default {"price":"xja-z","onSale":"yja-z","msrpLabelPrice":"zja-z","msrpLabel":"Aja-z","originalPrice":"Bja-z"};